module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHAQMAAAD+nMWQAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAABNJREFUCB1j4GASYFJgcmD+A4IADUIDfIUMT4wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/menu-collapsed-rtl.png
// module id = 204
// module chunks = 0